var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15992 8.76349H5.29825C3.39158 8.76349 1.83325 7.20519 1.83325 5.29852C1.83325 3.39186 3.39158 1.8335 5.29825 1.8335H7.03076C8.46076 1.8335 9.62492 3.00685 9.62492 4.42768V6.77434V15.6751C9.62492 16.6285 8.84574 17.4077 7.8924 17.4077C6.93907 17.4077 6.15992 16.6285 6.15992 15.6751V8.76349Z",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29844 6.15981C4.82177 6.15981 4.43677 5.77486 4.43677 5.29819C4.43677 4.82153 4.82177 4.43652 5.29844 4.43652",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.84 8.76349H16.7017C18.6083 8.76349 20.1667 7.20519 20.1667 5.29852C20.1667 3.39186 18.6083 1.8335 16.7017 1.8335H14.9692C13.5392 1.8335 12.375 3.00685 12.375 4.42768V6.77434V15.6751C12.375 16.6285 13.1542 17.4077 14.1075 17.4077C15.0608 17.4077 15.84 16.6285 15.84 15.6751V8.76349Z",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7017 6.15981C17.1783 6.15981 17.5633 5.77486 17.5633 5.29819C17.5633 4.82153 17.1783 4.43652 16.7017 4.43652",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79175 20.1665V17.4165",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2083 20.1665V17.4165",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.f63e29c53b3a1cb25144d948df62cc76.svg";
export { ForwardRef as ReactComponent };